var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.canNavigateToInformation)?_c('v-btn',{attrs:{"outlined":"","color":"accent","to":"/information/manuals"}},[_vm._v(" "+_vm._s(_vm.$t("support.labels.manual"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }